export default "__VITE_ASSET__9TtwKwXj__"